import { scanInternals } from './scanInternals';
import { Observable } from '../Observable';
export function reduce(accumulator, seed) {
    var hasSeed = arguments.length >= 2;
    return function (source) { return new Observable(function (subscriber) { return scanInternals(accumulator, seed, hasSeed, false, true, source, subscriber); }); };
}
//# sourceMappingURL=reduce.js.map